import type { PublicBuildingState as BuildingState } from "@point/core";
import { getBuildingHeightPixels } from "./buildingGeometry.ts";
import { isoToScreen } from "./iso.ts";

export function computeCityBounds(buildings: BuildingState[]): {
	minX: number;
	maxX: number;
	minY: number;
	maxY: number;
	width: number;
	height: number;
} {
	let minX = Infinity;
	let maxX = -Infinity;
	let minY = Infinity;
	let maxY = -Infinity;

	for (const b of buildings) {
		const [gx, gz] = b.gridPos;
		const { x: cx, y: cy } = isoToScreen(gx, gz);
		const h = getBuildingHeightPixels(b);

		const padX = 52;
		const padTop = h + 48;
		const padBot = 32;

		minX = Math.min(minX, cx - padX);
		maxX = Math.max(maxX, cx + padX);
		minY = Math.min(minY, cy - padTop);
		maxY = Math.max(maxY, cy + padBot);
	}

	if (!Number.isFinite(minX)) {
		return { minX: -280, maxX: 280, minY: -280, maxY: 280, width: 560, height: 560 };
	}

	return {
		minX,
		maxX,
		minY,
		maxY,
		width: maxX - minX,
		height: maxY - minY,
	};
}
